import { S102gS102m01Component } from './s102g-s102m01.component';

export { S102gModule } from './s102g.module';

export const S102gSubComponentsMap = {
	
};

export const S102gComponentsMap = {
	"s102g-s102m01": S102gS102m01Component
};

export const S102gComponents = [
	S102gS102m01Component
];

